import {Repository, RequestMethod} from 'b302-frontend-library';
import University from '../models/University';
import {UniversityPart} from './UniversityRepository';

export interface CompareSection {
    title: string;
    results: number[];
    extras: string[];
}

export type CompareWithPartsResponse = UniversityPart[];

export interface CompareResponse {
    universities: University[];
    sections: CompareSection[];
    reviews: string[];
}

class CompareRepository extends Repository {

    public constructor() {
        super('/compare');
    }

    public compare(universities: number[]) {
        return this.requestWithOptions<CompareResponse>(this.url(), RequestMethod.GET, {
            params: { university_ids: universities.join(',') }
        }).send();
    }

    public facilities(universities: number[]) {
        return this.compareWithPart(universities, 'facilities');
    }

    public academicProgram(universities: number[]) {
        return this.compareWithPart(universities, 'academic-program');
    }

    public costs(universities: number[]) {
        return this.compareWithPart(universities, 'costs');
    }

    public accommodation(universities: number[]) {
        return this.compareWithPart(universities, 'accommodation');
    }

    public compareWithPart(universities: number[], part: string) {
        return this.requestWithOptions<CompareWithPartsResponse>(this.url('/with-parts'), RequestMethod.GET,{
            params: { university_ids: universities.join(','), part }
        }).send();
    }
}

export default CompareRepository;
